<template>
  <panel class="case-oxygens" title="Oxygen" color="green-7">
    <case-actions
      :available-actions="oxygens"
      :selected-actions="caseConf._oxygens"
      :errors="errors"
      :warnings="warnings"
      :readonly="readonly"
      color="green-7"
      @update="update"
    />
  </panel>
</template>

<script>
import get from 'lodash/get';

import Panel from '../../common/Panel';
import CaseActions from '../../common/CaseActions';

export default {
  name: 'case-oxygens',
  components: {
    CaseActions,
    Panel,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    oxygens: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errors() {
      return get(
        this.$store.getters['validation/errorsByFieldAndId'],
        '_oxygens',
      );
    },
    warnings() {
      return get(
        this.$store.getters['validation/visibleWarningsByFieldAndId'],
        '_oxygens',
      );
    },
  },
  methods: {
    update(oxygens) {
      this.$emit('update', { _oxygens: oxygens });
    },
  },
};
</script>

<style scoped>
</style>
